
const avatar = require('../assets/images/avatar.jpg');
function SidePanel() {
	return (
		<div id="header">

			<header >
				<div className="inner">
					{/* <a href={"#"} className="image avatar"> */}
					<img className="image avatar" src={avatar} alt="" />
					{/* </a> */}
					<h1>Hi! I am <strong>Shahan</strong>, a Ph.D. student
						in Human-Centered Computing at Clemson University.
					</h1>
					<p>
						<strong>Email:</strong> mehtabi [at] clemson [dot] edu
					</p>
				</div>
			</header >
			<footer id="footer">
				<div className="inner">
					<ul className="icons">
						<li>
							<a href="https://twitter.com/shahanM" className="icon brands fa-twitter">
								<span className="label">Twitter</span>
							</a>
						</li>
						<li>
							<a href="https://github.com/ShahanM" className="icon brands fa-github">
								<span className="label">Github</span>
							</a>
						</li>
						{/* <li>
							<a href="https://www.linkedin.com/in/shahanm/" className="icon brands fa-linkedin">
								<span className="label">LinkedIn</span>
							</a>
						</li> */}
						<li>
							<a href="https://www.instagram.com/ishahanm/" className="icon brands fa-instagram">
								<span className="label">Instagram</span>
							</a>
						</li>
						<li>
							<a rel="me" href="https://hachyderm.io/@iShahanM" className="icon brands fa-mastodon">
								<span className="label">Mastodon</span>
							</a>
						</li>
						{/* <li><a href="https://medium.com/@shahanm" class="icon brands fa-medium-m"><span class="label">Instagram</span></a></li> */}
						<li>
							<a href="https://scholar.google.com/citations?hl=en&user=r2xe5DEAAAAJ" className="icon academic ai-google-scholar">
								<span className="label">Google Scholar</span>
							</a>
						</li>
						<li>
							<a href="https://www.semanticscholar.org/author/Mehtab-Iqbal/2069559779" className="icon academic ai-semantic-scholar">
								<span className="label">Semantic Scholar</span>
							</a>
						</li>
						{/* <li><a href="#" class="icon solid fa-envelope"><span class="label">Email</span></a></li> */}
					</ul>
					<ul className="copyright">
						<li>&copy; Mehtab Iqbal</li>
						{/* <li>Design: <a href="https://html5up.net">HTML5 UP</a></li> */}
					</ul>
					<p className='disclaimer'>
						<strong>Disclaimer:</strong> I am a Ph.D. student and I sometimes lose track of time.
						So, this Website is perpetually under construction. If you come across any inconsistencies,
						please let me know. Also, it is highly likely that I overlooked something or did not finish
						editing part before publishing. Rest assured that I will fix it as soon as I notice.
					</p>
				</div>
			</footer>
		</div >
	);
}

export default SidePanel;